export var GROW_SHARE_ROUTES = {
    INTERNSHIP: '/internship',
    EMPLOYER: '/employer',
    COMPETENCY: '/competency',
    UNIVERSITY: '/university',
};
export var buildShareUrl = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var contentNugget = _a.contentNugget, growUrl = _a.growUrl, appRoute = _a.appRoute;
    var defaultShareUrl = "".concat(growUrl, "/nuggets?nugget=").concat(contentNugget.slug);
    switch (contentNugget.variant) {
        case 'scholarships':
            return "".concat(growUrl, "/nuggets?scholarship=").concat((_b = contentNugget.scholarship_info) === null || _b === void 0 ? void 0 : _b.id);
        case 'internship':
            return "".concat(growUrl).concat(appRoute.INTERNSHIP, "/").concat((_c = contentNugget.internship_info) === null || _c === void 0 ? void 0 : _c.id);
        case 'profile-internal':
            return "".concat(growUrl, "/profile/").concat((_d = contentNugget.profile_info) === null || _d === void 0 ? void 0 : _d.id);
        case 'profile-external':
            return "".concat((_e = contentNugget.external_profile_info) === null || _e === void 0 ? void 0 : _e.url);
        case 'career-path':
            return "".concat(growUrl, "/career-paths/").concat((_f = contentNugget.career_path_info) === null || _f === void 0 ? void 0 : _f.id);
        case 'post':
            return "".concat(growUrl, "?post=").concat((_g = contentNugget.post_info) === null || _g === void 0 ? void 0 : _g.id);
        case 'generated-content':
            return "".concat(growUrl, "/nuggets?generated-content=").concat((_h = contentNugget.generated_content_info) === null || _h === void 0 ? void 0 : _h.uuid);
        case 'employer':
            return "".concat(growUrl).concat(appRoute.EMPLOYER, "/").concat((_j = contentNugget.employer_info) === null || _j === void 0 ? void 0 : _j.slug);
        case 'competency':
            return "".concat(growUrl).concat(appRoute.COMPETENCY, "/").concat(contentNugget.slug);
        case 'institution':
            if (contentNugget.college_info) {
                return "".concat(growUrl).concat(appRoute.UNIVERSITY, "/").concat(contentNugget.college_info.id);
            }
            return defaultShareUrl;
        case 'tool':
            if (((_k = contentNugget.tool_info) === null || _k === void 0 ? void 0 : _k.navigation.type) === 'INTERNAL') {
                return "".concat(growUrl).concat(contentNugget.tool_info.navigation.internal_navigation_url);
            }
            if (((_l = contentNugget.tool_info) === null || _l === void 0 ? void 0 : _l.navigation.type) === 'EXTERNAL') {
                return contentNugget.tool_info.navigation.external_navigation_url;
            }
            return defaultShareUrl;
        case 'major':
            return "".concat(growUrl, "/majors/").concat((_m = contentNugget.major_info) === null || _m === void 0 ? void 0 : _m.id);
        case 'industry':
            return "".concat(growUrl, "/industries/").concat((_o = contentNugget.industry_info) === null || _o === void 0 ? void 0 : _o.id);
        case 'coach':
            return "".concat(growUrl, "/profile/").concat((_p = contentNugget.coach_info) === null || _p === void 0 ? void 0 : _p.id);
        case 'deep-dive':
            return "".concat(growUrl, "/deep-dives/").concat((_q = contentNugget.deep_dive_info) === null || _q === void 0 ? void 0 : _q.id);
        default:
            return defaultShareUrl;
    }
};
